/* eslint-disable @typescript-eslint/no-explicit-any */
import { defineStore } from 'pinia';
import { ComputedRef, Ref, computed } from 'vue';
import { AccessApiService } from '~packages/epk-front-shared/api-client';
import { useOrg } from '~packages/epk-org-client';

export interface IStateRight {
  as: AccessApiService;
  employeeList: Ref<any[]>;
  isInited: ComputedRef<boolean>;
  isLoading: boolean;
}

export const useRightStore = defineStore('right', {
  state: (): IStateRight => {
    const { employeeList, init: orgInit, isInited } = useOrg();

    orgInit();

    return {
      as: new AccessApiService(),
      employeeList,
      isInited: computed(() => isInited.value),
      isLoading: false,
    };
  },
  getters: {
    hasRightWrite() {
      return this._check('type_right_read_write');
    },
  },
  actions: {
    _check(k: string) {
      const employeeListVal = this.employeeList as any[];

      const i = employeeListVal.find(i => i.user.user_is_me);
      if (!i) return false;

      return i.accesses.some(i => i[k]);
    },
    checkCanRead(route) {
      return (
        route.meta.always ||
        this._check(
          route.meta.readWriteOnly
            ? 'type_right_read_write'
            : 'type_right_read_only'
        )
      );
    },
  },
});
